module.exports = __webpack_public_path__ + "img/banner.ed5148ce.jpeg";